import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Snackbar from '@material-ui/core/Snackbar';
import { approvePaymentRequest, rejectPaymentRequest, validateGSTN, validatePaymentRequest } from '../utils/PaymentRequestApiUtils'
import token from '../config/jwt_token'
import userdata from '../config/jwt_token';

class MultipleApprovals extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            selectedRows: 0,
            totalAmount: 0,
            dialogBox: false,
            dialogBoxText: '',
            snackMessage: '',
            approveDialogBox: false,
            approveddialogBoxText: '',
            approveddialogBoxTitle: '',
            isApprove:false,
            comment: undefined,
            commentErrText: '',
            commentErr: false,
            invoice_number_exists:false,
            inRequest: false,
        }
    }
    componentWillReceiveProps(nextProps) {
        if(nextProps.viewMode == 'accountingReport') {
            const set = new Set();
            nextProps.data.forEach(data => {
                set.add(data.payment_request_id)
            });

            this.setState({
                comment:undefined, 
                commentErr: false, 
                commentErrText: '', 
                selectedRows: set.size,
            });
        } else {
            let data = nextProps.data.map(data => {
                return {
                    payment_request_id: data.all_data.payment_request.payment_request_id,
                    payment_request_transaction_log_id: data.all_data.payment_request_transaction_log_id,
                    invoice_number: data.all_data.payment_request.invoice_number,
                    vendor_id: data.all_data.payment_request.vendor_id,
                    type_of_payment: data.all_data.payment_request.type_of_payment,
                    vendor_code: data.all_data.payment_request.vendor_code,
                    date_of_invoice: data.date_of_invoice ? new Date(data.date_of_invoice) : null,
                    bill_submission_data: data.all_data.bill_submission_data ? data.all_data.bill_submission_data : null,
                }
            })
            let totalAmount = 0
            nextProps.data.forEach(data => {
                totalAmount = totalAmount + data.all_data.payment_request.total_payable_amount
            })
            this.setState({ 
                totalAmount, 
                data, 
                comment:undefined, 
                commentErr: false, 
                commentErrText: '', 
                selectedRows: data.length,
            });
        }
    }
    handleDialogBox = (value) => {
        const isApprove = value === 'approve';
        const baseDialogInfo = {
            approveDialogBox: true,
            isApprove
        };
        if (isApprove) {
            const paymentOnHold = userdata.role.indexOf('Central Finance') !== -1 ? this.state.data.filter(datum => 
                datum.bill_submission_data && (datum.bill_submission_data.paymentHoldAtProcessed == true || datum.bill_submission_data.paymentHoldAtProcessed == 1)
            ) : [];
            this.setState({
                ...baseDialogInfo,
                approveddialogBoxTitle: 'Are you sure you want to approve this request(s)?',
                approveddialogBoxText: paymentOnHold.length > 0
                    ? `Some payment(s) including IDs: ${paymentOnHold.map(p => p.payment_request_id).join(', ')} will be put on hold in Processed Payments. Please add comments for approval.`
                    : 'Please enter your comments for all the approved requests'
            });
        } else {
            this.setState({
                ...baseDialogInfo,
                approveddialogBoxTitle: 'Are you sure you want to reject this request(s)?',
                approveddialogBoxText: 'Please enter your comments for all the rejected requests'
            });
        }
    }
    handleNo() {
        this.setState({ approveDialogBox: false, comment: undefined, commentErr: false, commentErrText: ''})
    }
    handleYes() {
        if(this.state.isApprove === true) 
        {
            if(this.state.comment === undefined || this.state.comment === '')
                this.setState({commentErr: true, commentErrText: 'Please add a comment'})
            else 
                this.setState({ inRequest: true }, this.multiAprroval);
        }
        else
        {
            if(this.state.comment === undefined || this.state.comment === '')
                this.setState({commentErr: true, commentErrText: 'Please add a comment'})
            else 
                this.setState({ inRequest: true }, this.multiReject);
            
        }
    }

    validateInvoiceNumbers = async () => {
        let invoice_number_flag = {};
        let data = this.state.data;
        let itemsProcessed = 0;
        let selected_invoice_numbers = new Set();
        let promise;
        data.forEach(datum => {
            itemsProcessed++;
            if(token.role === 'City Head' && datum.type_of_payment === 'Final Settlement') {
                if (!(selected_invoice_numbers.has(JSON.stringify({vendor:datum.vendor_code, invoice:datum.invoice_number})))) {
                    promise = Promise.resolve(validatePaymentRequest(datum.vendor_code, datum.invoice_number, datum.date_of_invoice))
                    .then(response => {
                        if (response) {
                            if (response.status === 'failure') {
                                invoice_number_flag={
                                    flag: true,
                                    message: response.message || "Invoice already approved for the vendor(s)"
                                };
                            }
                        }
                    })
                } 
                else {
                    invoice_number_flag={
                        flag: true,
                        message: "Invoice already approved for the vendor(s)"
                    };
                }
                selected_invoice_numbers.add(JSON.stringify({vendor:datum.vendor_code, invoice:datum.invoice_number}));
            } else {
                promise = Promise.resolve(validateGSTN(datum.vendor_code))
               .then(response => {
                    if (response.flag) {
                        if (response.data[0].gstn_status == "CANCELLED" || response.data[0].gstn_status == "SUSPENDED") {
                            invoice_number_flag={
                                flag: true,
                                message: `GST status is ${response.data[0].gstn_status} for invoice ${datum.invoice_number}`
                            };
                        }
                    }
                })
            }
        });
        if(Promise.resolve(promise) == promise){
            promise.then(() => {
                if(itemsProcessed === data.length) {
                    this.setState({ inRequest: false })
                    this.invoice_number_handler(invoice_number_flag);
                }
            })
        }
        else {
            if(itemsProcessed === data.length) {
                this.setState({ inRequest: false })
                this.invoice_number_handler(invoice_number_flag);
            }
        }
    }

    invoice_number_handler(data) {
      if(data.flag)
        this.setState({invoice_number_exists : data.flag, snackOpen: data.flag, snackMessage: data.message})
      else 
        this.handleDialogBox('approve')
    }

    handleComment(event) {
        this.setState({ comment: event.target.value });
      }
    clearErr() {
        this.setState({commentErr: false, commentErrText: ''})
    }
    async multiAprroval() {
        this.setState({ approveDialogBox: false})
        let data = this.state.data;
        data.forEach(datum => {
            datum.remarks = this.state.comment;
        })
        let body = JSON.stringify(data)
        approvePaymentRequest(body).then(response => {
            if (response) {
                if (response.status === 'success') {
                    // once approved the data is cleared
                    this.setState({ dialogBox: true, dialogBoxText: response.message, data: Array.isArray(response.errorPrIds) ? response.errorPrIds : [], inRequest : false })
                }
                else {
                    this.setState({ snackMessage: response.message, snackOpen: true, inRequest : false })
                }
            }
        })
    }
    async multiReject() {
        this.setState({ approveDialogBox: false})
        let data = this.state.data;
        data.forEach(datum => {
            datum.remarks = this.state.comment;
        })
        let body = JSON.stringify(this.state.data)
        rejectPaymentRequest(body).then(response => {
            if (response) {
                if (response.status === 'success') {
                    this.setState({ dialogBox: true, dialogBoxText: response.message, data:[], inRequest : false })
                }
                else {
                    this.setState({ snackMessage: response.message, snackOpen: true, inRequest : false })
                }
            }
        })
    }
    handleCloseSnack() {
        this.setState({ snackOpen: false })
    }
    handleOk() {
        this.setState({ dialogBox: false })
        this.props.handleOk()
    }
    render() {
        return (
            <MuiThemeProvider>
                <Dialog
                    open={this.state.approveDialogBox}
                    onClose={this.handleNo.bind(this)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="form-dialog-title">{this.state.approveddialogBoxTitle}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                        {this.state.approveddialogBoxText}
                        </DialogContentText>
                        <TextField
                            autoFocus
                            onClick={this.clearErr.bind(this)}
                            onChange={this.handleComment.bind(this)}
                            helperText={this.state.commentErrText}
                            error={this.state.commentErr}
                            margin="dense"
                            id="comment"
                            label="*Comment"
                            type="text"
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleNo.bind(this)} color="primary">
                        No
                        </Button>
                        <Button onClick={ this.handleYes.bind(this)} color="primary" autoFocus>
                        Yes
                        </Button>
                    </DialogActions>
                </Dialog>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <TextField
                        label={this.props.viewMode === 'accountingReport' ? "Total Selected Payment(s)" : "Total Selected Rows"}
                        margin='normal'
                        disabled={true}
                        value={this.state.selectedRows === 0 ? '' : this.state.selectedRows}
                        style={{ width: '250px', marginLeft: '20px' }}
                    />
                    {this.props.viewMode !== 'accountingReport' && (
                        <TextField
                            label="Total  Amount"
                            margin='normal'
                            disabled={true}
                            value={this.state.totalAmount === 0 ? '' : this.state.totalAmount}
                            style={{ width: '250px', marginLeft: '20px' }}
                        />
                    )}
                </div>
                { window.location.pathname === '/vendor/payment/approve' &&
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px', }}>
                        <Button 
                            variant="contained" 
                            size="large" 
                            style={{
                                backgroundColor: ((!this.state.inRequest) && this.state.data.length > 0) ? 'rgb(121,183,79)' : 'grey',
                                color:'white'
                            }} 
                            disabled={!((!this.state.inRequest) && this.state.data.length > 0)} 
                            onClick={() => {
                                this.setState({
                                    inRequest: true
                                }, this.validateInvoiceNumbers.bind(this))
                            }}>
                            Approve
                            </Button>
                        <Button variant="contained" size="large" style={{ marginLeft: '20px', backgroundColor:(this.state.data.length != 0 && !this.state.inRequest)?'rgb(220,20,60)':'grey',color:'white' }} disabled={!(this.state.data.length != 0 && !this.state.inRequest)} onClick={this.handleDialogBox.bind(this, 'reject')}>
                            Reject
                            </Button>
                    </div>}
                <Dialog
                    open={this.state.dialogBox}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.state.dialogBoxText}
                        </DialogContentText>
                        {this.state.data.length > 0 && (
                            <DialogContentText id="alert-dialog-description">
                                <br />
                                The following request IDs may have a new status:
                                <br />
                                {' '}{this.state.data.join(', ')}.
                                <br />
                                <br />
                                Please refresh the page to see the latest information.
                            </DialogContentText>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleOk.bind(this)} color="primary" autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
                <Snackbar
                    open={this.state.snackOpen}
                    message={this.state.snackMessage}
                    autoHideDuration={5000}
                    onClose={this.handleCloseSnack.bind(this)}
                />
            </MuiThemeProvider>
        )
    }
}

export default MultipleApprovals


// WEBPACK FOOTER //
// ./src/components/MultipleApprovals.js